<template>
  <div id="mypage" class="rew18-contents">
<!--    <div class="rew18-contents-banner rew19_missTop" style="background-image: url('https://resource2018.nuskinkorea.co.kr/images/renew/mypage/mypage_bg.png')">-->
    <div class="rew18-contents-banner rew19_missTop">

      <div class="rew18-contents-banner__text">
        <h1>로그아웃</h1>
        <p><strong>뉴스킨 코리아</strong>에 <br class="m-br"> 오신 것을 환영합니다.</p>
      </div>

    </div>

    <div class="rew18-contents-inner">

      <div class="login-box">
        <div class="login-box__form" style="border: none;">
          <form method="post" id="member" name="member">
            <input type="hidden" name="refer1" value=""/>
            <input type="hidden" name="refer2" value=""/>
            <input type="hidden" name="userRefer" value=""/>

            <div class="login-box__button">
              <!--<button type="button" onclick="javascript:joinSubmit();">로그인</button>-->
              <button type="button" @click="onClickLogin();">로그아웃</button>
            </div>

          </form>
        </div>

      </div>

    </div>

  </div>

</template>
<script>
import AroBase from '@/components/base/AroBase';

import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import PageNav from "@/components/paging/pageNav";

export default {
  name: "aroLogout",
  extends: AroBase,
  components: {
    PageNav,
  },
  computed: {
    accordionClasses: function () {
      return {
        'state_close': !this.isOpen,
        'state_open': this.isOpen
      };
    }
  },

  data() {
    //View Data
    return {
      isOpen: false,
      viewData: {
        master_list: []
      },

      //주문상품 변경
      productChangeDialog: {},

      // aro 장바구니 이름 변경
      aroNameChangeDialog: {},
    }
  },

  created() {

  },
  mounted() {
    let _this = this;

    //_this.loadList(1);
  },

  methods: {

    /**
     * API Request
     */
    toggle: function (item) {
      //this.isOpen = !this.isOpen;
      if (this.isOpen === item.aro_no) {
        this.isOpen = false;
      } else {
        this.isOpen = item.aro_no;
      }
    },

    apiGetAro(pageNo) {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_aro`, {
        params: {
          isUspan: '',
          page: pageNo,
          countPerPage: 10
        }
      });
    },

    // 주문상품 변경
    apiChangeProduct(aro_no, pd_add_list) {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_product`, {
        params: {
          aro_no: aro_no,
          pd_add_list: JSON.stringify(pd_add_list)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    //ARO 변경 가능 여부 체크
    apiCheckAroModifyStatus: function (aro_no) {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/modify_status`, {
        params: {
          adpNo: aro_no
        }
      });
    },

    // aro 장바구니 이름 변경
    apiAroPutTags: function (aro_no, aro_tag) {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_tags`, {
        params: {
          adpNo: aro_no,
          aroTag: aro_tag
        }
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadList(pageNo) {
      let _this = this;

      //init data
      _this.viewData = {
        ..._this.viewData,
        countPerPage: _this.countPerPage,
        page: 1,
        totalHistory: 0,
        history_list: []
      };
    },

    onClickPage(pageNo) {
      let _this = this;

      _this.loadList(pageNo);
    },

    //상세 이동
    onClickDetail(item) {
      let _this = this;
    },

    //Open dialog 주문상품 변경
    openProductChangeDialog(aro_no, list, prod_add_yn, payment_count) {
      let _this = this;

      //pass data to dialog
      _this.productChangeDialog = {
        ..._this.productChangeDialog,
        pd_list: list,
        aro_no: aro_no,
        aro_payment_count: payment_count,
      };
    },

    //주문상품 변경
    productChange(isOk, data) {
      let _this = this;

    },

    //Open dialog aro 장바구니 이름 변경
    openAroNameChangeDialog(aro_no, aro_tag) {
      let _this = this;

      //pass data to dialog
      _this.aroNameChangeDialog = {
        ..._this.aroNameChangeDialog,
        aro_no: aro_no,
        aro_tag: aro_tag
      };
    },

    // aro 장바구니 이름 변경
    aroNameChange(isOk, data) {
      let _this = this;

    },

    apiAutoPaymentDate() {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/autoPaymentDate`, {
        params: {}
      });
    },

    //상품 클릭
    /*
    onClickLogin() {
      console.debug(`aroLogin onClickLogin`);

      let _this = this;

      const memberIdVal = _this.member_id;
      const memberPwVal = _this.passwd;

      console.debug(`aroLogin memberIdVal = ` + memberIdVal + ' memberPwVal = ' + memberPwVal);

      let formData = new FormData(document.getElementById('member'));
      //let formData = new FormData();
      formData.append('member_id', memberIdVal);
      formData.append('passwd', memberPwVal);

      console.debug(`aroLogin formData memberIdVal = ` + formData.get('member_id') + ' memberPwVal = ' + formData.get('passwd'));

      _this.$showLoading();
      _this.$http.post(`${_this.$aroApiBasePath}/app/mo/Login`, formData, {
        params: {
          refer2:'12323',
        },

        // member: {
        //   member_id: memberIdVal,
        //   passwd: memberPwVal,
        // },

        headers: {
          'Content-type': 'application/x-www-form-urlencoded',
        },

        //
        // body: {
        //   member: {
        //     member_id: memberIdVal,
        //     passwd: memberPwVal,
        //   },
        // }

      }).then(res => {
        if (res.status === 200) {
          //_this.$router.push(`${_this.$aroBasePath}/basket`);
        }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },
    */

    onClickLogin() {
      console.debug(`aroLogin onClickLogin`);

      let _this = this;

      //_this.$http.defaults.withCredentials = true;

      _this.$showLoading();
      _this.$http.get(`${_this.$aroApiBasePath}/app/mo/Logout`, {
      //_this.$http.get(`http://10.132.101.183/app`, {
        params: {
        },

        //credentials: "include",

      }).then(res => {
        if (res.status === 200) {
          //_this.$router.push(`${_this.$aroBasePath}/basket`);
          _this.$router.push(`${_this.$aroBasePath}/list`);
        }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },
  }
}
</script>
<style>
.rew19_btn_blackarrow, .rew19_btn_upDown{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/my/aro/aroLogout.vue